export type InvoicePdfDelivery = 'downloaded' | 'opened' | 'shared' | 'cancelled';

export const deliverInvoicePdf = async (blob: Blob, fileName: string): Promise<InvoicePdfDelivery> => {
    if (!blob || blob.size === 0) {
        throw new Error('Empty PDF response');
    }
    if (blob.type && blob.type !== 'application/pdf') {
        throw new Error('Unexpected file type returned');
    }
    if (!/^[A-Za-z0-9._-]+\.pdf$/i.test(fileName)) throw new Error('Invalid invoice file name');

    if ((window as any).cordova) {
        const { openInvoicePdfPreview } = await import('./InvoicePdfPreview');
        openInvoicePdfPreview(blob, fileName);
        return 'opened';
    }

    const blobUrl = window.URL.createObjectURL(blob);
    try {
        const anchor = document.createElement('a');
        anchor.href = blobUrl;
        anchor.download = fileName;
        if (typeof anchor.download !== 'undefined') {
            document.body.appendChild(anchor);
            anchor.click();
            anchor.remove();
        } else {
            window.open(blobUrl, '_blank');
        }
        return 'downloaded';
    } finally {
        setTimeout(() => window.URL.revokeObjectURL(blobUrl), 1500);
    }
};
